import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { startWith, map, BehaviorSubject } from 'rxjs';
import { TUI_DEFAULT_MATCHER } from '@taiga-ui/cdk';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { JobTitleUI } from '@src/models';

import { JobTitleFieldSize } from './types';

@Component({
  selector: 'app-job-title-field',
  templateUrl: './job-title-field.component.html',
  styleUrls: ['./job-title-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTitleFieldComponent extends AbstractTuiControl<string[]> {
  @Input({ required: true }) jobTitles: JobTitleUI[] | null = null;

  @Input() size: JobTitleFieldSize = 'l';
  @Input() loading = false;

  /** Количество видимых строк в поле ввода */
  @Input() rows = 10;

  /** Визуальное представление выбранных элементов */
  @Input() showAsChips = false;

  readonly search$ = new BehaviorSubject<string>('');

  readonly filteredJobTitles$ = this.search$.pipe(
    startWith(''),
    map(search => {
      return this.jobTitles?.filter(({ jobTitleName }) => TUI_DEFAULT_MATCHER(jobTitleName, search));
    }),
  );

  get required() {
    return this.control?.hasValidator(Validators.required);
  }

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): string[] {
    return [];
  }

  protected readonly stringify = (jobTitleId: string): string => {
    return this.jobTitles?.find(jobTitle => jobTitle.jobTitleId === jobTitleId)?.jobTitleName ?? '';
  };
}
